import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardSection,
  CardSectionControl,
  CardSectionDescription,
  CardSectionTitle,
  CardTitle,
  Group,
} from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { graphSettingsRouteConfig } from '../../routes';

export const ProposalImplementationCard = () => {
  const location = useLocation();
  return (
    <Card>
      <CardHeader>
        <CardTitle>Proposal implementation</CardTitle>
      </CardHeader>
      <CardBody>
        <CardSection className="flex-row">
          <Group orientation="vertical">
            <CardSectionTitle>Proposal checks</CardSectionTitle>
            <CardSectionDescription>
              Go to checks configurations to update the settings for proposal
              checks.
            </CardSectionDescription>
          </Group>
          <CardSectionControl>
            <Button
              variant="secondary"
              className="mt-4 w-fit md:mt-0"
              as={Link}
              to={graphSettingsRouteConfig.locationFrom({
                location,
                patch: { tab: 'checks_proposals' },
              })}
            >
              Proposal check settings
            </Button>
          </CardSectionControl>
        </CardSection>
      </CardBody>
    </Card>
  );
};
